import { create } from 'zustand';

/**
 * Per-CLAUDE.md: session-store. Volatile (not persisted) — session lives in memory.
 * RFC-0014 will define the server-side session contract.
 *
 * `sessionId` is the correlation id stamped on every SignalEvent emitted
 * during this session. Resets on `reset()`.
 */
interface SessionState {
  sessionId: string;
  startedAt: number;
  lastInteractionAt: number;
  conceptIdsTouched: string[];
  touch: (conceptId?: string) => void;
  reset: () => void;
}

const now = () => Date.now();
function uuid(): string {
  if (typeof crypto !== 'undefined' && 'randomUUID' in crypto) return crypto.randomUUID();
  return `s-${Math.random().toString(36).slice(2, 10)}`;
}

export const useSession = create<SessionState>((set) => ({
  sessionId: uuid(),
  startedAt: now(),
  lastInteractionAt: now(),
  conceptIdsTouched: [],
  touch: (conceptId) =>
    set((s) => ({
      lastInteractionAt: now(),
      conceptIdsTouched:
        conceptId && !s.conceptIdsTouched.includes(conceptId)
          ? [...s.conceptIdsTouched, conceptId]
          : s.conceptIdsTouched,
    })),
  reset: () =>
    set({ sessionId: uuid(), startedAt: now(), lastInteractionAt: now(), conceptIdsTouched: [] }),
}));
